import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _toConsumableArray } from '../../unsorted/toConsumableArray.js';
import { c as createFastContext } from '../../utils/createFastContext.js';
import { serializeChildren } from '../../utils/componentHelpers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  tooltipList: []
};
var CLEAR_TOOLTIP = "clearTooltip";
var STORE_TOOLTIP = "storeTooltip";
var UPDATE_TOOLTIP_CONTENT = "updateTooltipContent";
var tooltipReducer = function tooltipReducer(state, action) {
  switch (action.type) {
    case UPDATE_TOOLTIP_CONTENT:
      {
        var currentIndex = -1;
        state.tooltipList.forEach(function (tooltip, i) {
          if (tooltip.id === action.payload.id) {
            currentIndex = i;
          }
        });
        if (currentIndex >= 0) {
          // @TODO: this is a pretty shitty way to check if content has
          // changed, and could have pretty regrettable performance
          // but it's the only option we can think of right now...
          var newContentSerialised = serializeChildren(action.payload.content);
          var oldContentSerialised = serializeChildren(state.tooltipList[currentIndex].content);
          var contentHasChanged = newContentSerialised !== oldContentSerialised;
          if (contentHasChanged) {
            var updatedList = _toConsumableArray(state.tooltipList);
            updatedList[currentIndex].content = action.payload.content;
            return _objectSpread(_objectSpread({}, state), {}, {
              tooltipList: updatedList
            });
          }
          return state;
        }
        return state;
      }
    case STORE_TOOLTIP:
      {
        var newTooltipList = _toConsumableArray(state.tooltipList);
        var existingTooltip = state.tooltipList.find(function (tooltip) {
          return tooltip.id === action.payload.id;
        });
        var modifiedList = false;
        if (existingTooltip) {
          newTooltipList.forEach(function (tooltip, i) {
            if (tooltip.id === action.payload.id) {
              var newTooltip = serializeChildren(action.payload);
              var oldTooltip = serializeChildren(newTooltipList[i]);
              if (newTooltip !== oldTooltip) {
                newTooltipList[i] = action.payload;
                modifiedList = true;
              }
            }
          });
        } else {
          newTooltipList.push(action.payload);
          modifiedList = true;
        }
        return modifiedList ? _objectSpread(_objectSpread({}, state), {}, {
          tooltipList: newTooltipList
        }) : state;
      }
    case CLEAR_TOOLTIP:
      return _objectSpread(_objectSpread({}, state), {}, {
        tooltipList: state.tooltipList.filter(function (tooltip) {
          return tooltip.id !== action.payload.id;
        })
      });
    default:
      console.error("Unknown reducer action:", action);
      return state;
  }
};
var _createFastContext = createFastContext(initialState, tooltipReducer),
  BiomeTooltipProvider = _createFastContext.Provider,
  useTooltipStore = _createFastContext.useStore;
BiomeTooltipProvider.displayName = "BiomeTooltipProvider";

export { BiomeTooltipProvider as B, CLEAR_TOOLTIP as C, STORE_TOOLTIP as S, UPDATE_TOOLTIP_CONTENT as U, useTooltipStore as u };
//# sourceMappingURL=tooltipContext.js.map
